import React, { useEffect, useState } from 'react';
import { X, Clock, Send } from 'lucide-react';
import { useLanguage } from './LanguageContext';
import { AVAILABLE_SLOTS } from './MeetingRequestsContext';
interface Props {
  isOpen: boolean;
  title?: string;
  onClose: () => void;
  onSubmit: (slotId: string) => void;
  submitLabelKey?: string; // i18n key for the submit button
}
export function ProposeTimeSheet({
  isOpen,
  title,
  onClose,
  onSubmit,
  submitLabelKey = 'meeting.send'
}: Props) {
  const {
    t
  } = useLanguage();
  const [selectedSlot, setSelectedSlot] = useState<string | null>(null);
  useEffect(() => {
    if (!isOpen) setSelectedSlot(null);
  }, [isOpen]);
  if (!isOpen) return null;
  return <div className="absolute inset-0 z-50 flex flex-col justify-end" data-id="element-219">
      <div className="absolute inset-0 bg-black/60 backdrop-blur-sm animate-in fade-in duration-200" onClick={onClose} data-id="element-220" />
      <div className="relative bg-[#141414] rounded-t-2xl border-t border-[#2A2A2A] pt-6 pb-8 px-6 animate-in slide-in-from-bottom-full duration-300" data-id="element-221">
        <div className="flex items-center justify-between mb-2" data-id="element-222">
          <h2 className="text-[16px] text-white font-semibold" data-id="element-223">
            {title ?? t('meeting.proposeTitle')}
          </h2>
          <button onClick={onClose} aria-label={t('common.close')} className="w-8 h-8 bg-[#1A1A1A] rounded-full flex items-center justify-center text-[#888888] active:scale-95 border border-[#2A2A2A]" data-id="element-224">
            <X className="w-5 h-5" data-id="element-225" />
          </button>
        </div>
        <p className="text-[13px] text-[#A0A0A0] mb-5" data-id="element-226">
          {t('meeting.proposeSubtitle')}
        </p>

        <div className="flex flex-col gap-2 mb-6" data-id="element-227">
          {AVAILABLE_SLOTS.map(slot => {
          const isSelected = selectedSlot === slot.id;
          return <button key={slot.id} onClick={() => setSelectedSlot(slot.id)} className={`w-full flex items-center gap-3 px-4 py-3 rounded-xl border transition-colors text-left ${isSelected ? 'bg-[#C5D82D]/10 border-[#C5D82D] text-[#C5D82D]' : 'bg-[#1A1A1A] border-[#2A2A2A] text-white'}`} data-id="element-228">
                <Clock className={`w-4 h-4 shrink-0 ${isSelected ? 'text-[#C5D82D]' : 'text-[#6A6A6A]'}`} strokeWidth={2} data-id="element-229" />
                <div className="flex-1 min-w-0" data-id="element-230">
                  <div className="text-[14px] font-medium" data-id="element-231">
                    {t(slot.dayKey)}
                  </div>
                  <div className={`text-[12px] ${isSelected ? 'text-[#C5D82D]/80' : 'text-[#A0A0A0]'}`} data-id="element-232">
                    {t(slot.timeKey)}
                  </div>
                </div>
              </button>;
        })}
        </div>

        <button onClick={() => selectedSlot && onSubmit(selectedSlot)} disabled={!selectedSlot} className={`w-full py-4 rounded-full text-[14px] font-semibold tracking-wide flex items-center justify-center gap-2 transition-all ${selectedSlot ? 'bg-[#C5D82D] text-[#0D0D0D] active:scale-[0.98]' : 'bg-[#1A1A1A] text-[#6A6A6A] cursor-not-allowed border border-[#2A2A2A]'}`} data-id="element-233">
          <Send className="w-4 h-4" strokeWidth={2} data-id="element-234" />
          {t(submitLabelKey)}
        </button>
      </div>
    </div>;
}